import { AUTHS_ENDPOINTS } from 'src/services/consts/api.const'
import { httpService } from 'src/services/app/http.service'
import { log } from 'src/services/app/log.service'
import { refactorApproval, refactorMiniApproval } from 'src/services/helpers/approval.helper'
import { isObjectEmpty } from 'src/services/app/util.service'

export const approvalService = {
  getApprovalById,
  revokeApproval,
  approveConfirmation,
}

async function getApprovalById(approvalId) {
  const data = await httpService.post(AUTHS_ENDPOINTS.GET_AUTH_BY_ID, {
    user_auth_id: approvalId,
  })

  if (isObjectEmpty(data.user_auth_info)) {
    throw new Error('No approval data found')
  }
  const approval = refactorApproval({
    ...data.user_auth_info,
    user_auth_id: approvalId,
  })
  log.info('Fetched approval details for:', approval)
  return approval
}

async function revokeApproval(approvalId, revokeReason = null) {
  const payload = {
    user_auth_id: approvalId,
  }
  if (revokeReason) {
    payload.revoke_reason = revokeReason
  }
  const data = await httpService.post(AUTHS_ENDPOINTS.REVOKE_AUTH, payload)
  if (isObjectEmpty(data.user_auth_info)) {
    throw new Error('Failed to revoke approval')
  }
  const approval = refactorApproval({
    ...data.user_auth_info,
    user_auth_id: approvalId,
    revoke_reason: revokeReason,
  })

  return approval
}

async function approveConfirmation(approvalIds) {
  const payload = {
    approve_type: 'user_auth_id',
    user_auth_id: approvalIds,
  }
  const data = await httpService.post(AUTHS_ENDPOINTS.APPROVE_AUDIT, payload)

  if (!data.user_auths?.length) return []
  return data.user_auths
    .filter((approval) => approvalIds.includes(approval.user_auth_id))
    .map((approval) => refactorMiniApproval(approval))
}
